import { Box, Flex, Text, useColorModeValue } from "@chakra-ui/react";
import CardHeader from "../../purity/components/Card/CardHeader";
import CardBody from "../../purity/components/Card/CardBody";
import Card from "../../purity/components/Card/Card";
import React, { useEffect, useState } from "react";
import { QueryResult, useQuery } from "@apollo/client";
import { gql_queries } from "../../models/interface/gql_queries";
import { cdnUrl } from "../../environments/environments";
import { useNavigate } from "react-router-dom";
import { UI_Button } from "../UI_Components/UI_Button";
import { api_post_data } from "../../environments/api_handler";
import { AddIcon } from "@chakra-ui/icons";
import { Col, Row } from "react-bootstrap";
import { Typography } from "@mui/material";
import {
  home_page_singleblock_initial_state,
  HomePageSingleBlockMediaTypes,
  HomePageSingleBlockState,
} from "../../store/reducers/homepage_singleblock_info.reducer";
import { v4 } from "uuid";

const SingleBlockRows = ({
  overall_information_query,
}: {
  overall_information_query: QueryResult;
}) => {
  const textColor = useColorModeValue("gray.700", "white");
  const bgColor = useColorModeValue("#F8F9FA", "gray.800");
  const nameColor = useColorModeValue("gray.500", "white");

  const [servicesPageBlocks, setServicesPageBlocks] = useState<
    HomePageSingleBlockState[]
  >([]);

  useEffect(() => {
    const data = overall_information_query.data?.overall_information;

    if (data && data.service__nfc_card_page) {
      setServicesPageBlocks(data.service__nfc_card_page);
    }
  }, [overall_information_query.data]);

  const navigate = useNavigate();

  return (
    <>
      {servicesPageBlocks.map((item, i) => (
        <Box key={i} p="24px" bg={bgColor} my="22px" borderRadius="12px">
          <Flex justify="space-between" w="100%">
            <Flex direction="column" maxWidth="70%">
              <Text color={nameColor} fontSize="md" fontWeight="bold" mb="10px">
                {item.de.title}
              </Text>
              {item.medias.main_img.type ==
              HomePageSingleBlockMediaTypes.image ? (
                <>
                  <img
                    src={`${cdnUrl}/${item.medias.main_img.url}`}
                    className="mb-3"
                    style={{
                      width: 100,
                      height: "auto",
                      borderRadius: "1rem",
                    }}
                  />
                </>
              ) : (
                <>
                  <video
                    autoPlay
                    loop
                    preload="metadata"
                    playsInline
                    className="mb-3"
                    muted
                    style={{
                      width: 100,
                      height: "auto",
                      borderRadius: "1rem",
                    }}
                    data-hd="true"
                  >
                    <source
                      src={`${cdnUrl}/${item.medias.main_img.url}`}
                      type="video/mp4"
                    />
                    {`Your browser doesn't support HTML5 video tag.`}
                  </video>
                </>
              )}
              <Text color={textColor} fontSize="sm">
                <strong>ID:</strong> {item.ID.substring(0, 10)}...
              </Text>
            </Flex>
            <Flex
              direction={{ sm: "column", md: "row" }}
              align="flex-start"
              p={{ md: "24px" }}
            >
              <UI_Button
                color="error"
                className="mx-1"
                onClick={async () => {
                  if (!window.confirm("Are you sure?")) return;
                  await api_post_data(
                    "admin/delete_item_overall_information_arr_type",
                    {
                      name: "service__nfc_card_page",
                      ID: item.ID,
                    },
                  );
                  await overall_information_query.refetch();
                }}
              >
                <Typography variant="body1">
                  <span className="me-2">
                    <i className="fa-light fa-trash-can" />
                  </span>
                  Xóa
                </Typography>
              </UI_Button>
              <UI_Button
                color="primary"
                className="mx-1"
                onClick={() => navigate(`${item.ID}`)}
              >
                <Typography variant="body1">
                  <span className="me-2">
                    <i className="fa-light fa-pen" />
                  </span>
                  Sửa
                </Typography>
              </UI_Button>
            </Flex>
          </Flex>
        </Box>
      ))}
    </>
  );
};

export const ManageServicesPageBlocksPage__NfcCard = () => {
  const textColor = useColorModeValue("gray.700", "white");

  const overall_information_query = useQuery(gql_queries.overall_information, {
    fetchPolicy: "cache-and-network",
  });

  return (
    <Flex
      direction="column"
      pt={{ base: "120px", md: "75px" }}
      className="gap-3"
    >
      <Card my={{ lg: "24px" }} me={{ lg: "24px" }}>
        <Flex direction="column">
          <CardHeader py="12px">
            <Row className="justify-content-between w-100 align-items-center">
              <Col xs="auto" className="h-fit">
                <Text
                  color={textColor}
                  me="1rem"
                  fontSize="lg"
                  fontWeight="bold"
                >
                  Quản lý Block trang services
                </Text>
              </Col>
              <Col xs="auto" className="h-fit">
                <UI_Button
                  color="success"
                  onClick={async () => {
                    const service__nfc_card_page: HomePageSingleBlockState = {
                      ...home_page_singleblock_initial_state,
                      ID: v4(),
                    };
                    await api_post_data(
                      "admin/edit_overall_information_arr_type",
                      { service__nfc_card_page },
                    );
                    await overall_information_query.refetch();
                  }}
                >
                  <AddIcon className="me-2" /> Thêm block
                </UI_Button>
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            <Flex direction="column" w="100%">
              <SingleBlockRows
                overall_information_query={overall_information_query}
              />
            </Flex>
          </CardBody>
        </Flex>
      </Card>
    </Flex>
  );
};
